import * as React from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

export const ReturnInboundSection = ({ order }) => {
  if (!order?.returnInbound) {
    return null;
  }

  const { returnInbound, returnInboundItems = [] } = order;

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h5" textAlign="center">
          Return Inbound
        </Typography>
        <Typography textAlign="center" fontWeight="bold" sx={{ mb: 1 }}>
          Status: {returnInbound.status}
        </Typography>
        <Divider />
        <Box sx={{ p: 2 }}>
          {returnInboundItems.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>SKU</TableCell>
                  <TableCell align="right">Qty Requested</TableCell>
                  <TableCell align="right">Qty Received</TableCell>
                  <TableCell align="right">Qty Remaining</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {returnInboundItems.map((item) => {
                  const quantity = parseInt(item.quantity, 10) || 0;
                  const quantityReceived = parseInt(item.quantityReceived, 10) || 0;
                  return (
                    <TableRow key={item._id}>
                      <TableCell>{item.product?.name}</TableCell>
                      <TableCell>{item.product?.sku || item.product?.externalId}</TableCell>
                      <TableCell align="right">{quantity}</TableCell>
                      <TableCell align="right">{quantityReceived}</TableCell>
                      <TableCell align="right">{quantity - quantityReceived}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <Typography>No return inbound items recorded.</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ReturnInboundSection;
